<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="8">
                <el-input v-model="filter.text" prefix-icon="el-icon-search" :placeholder="$t('common.rmaNumber')"></el-input>
            </el-col>
        </el-row>
        <el-table size="mini" :data="rmaList" v-loading="loading" class="orders-table tablewithshading"
            @sort-change="sortRma">
            <el-table-column prop="rmaNumber" :label="$t('common.rmaNumber')" sortable="custom"></el-table-column>
            <el-table-column prop="invoiceNumber" :label="$t('common.invoiceNumber')"></el-table-column>
            <el-table-column prop="partNumber" :label="$t('common.partNum')"></el-table-column>
            <el-table-column prop="authorizationNumber" :label="$t('rma.authorNum')"></el-table-column>
            <el-table-column prop="rmaDate" :label="$t('rma.rmaDate')"></el-table-column>
            <el-table-column prop="serviceCompany" :label="$t('common.serviceCompany')"></el-table-column>
            <el-table-column prop="serviceTicketNumber" :label="$t('common.serviceTicketNum')"></el-table-column>
            <el-table-column prop="status" :label="$t('common.status')" sortable="custom">
                <template slot-scope="scope">
                    <p v-if="scope.row.status === `1`">{{$t('common.opened')}}</p>
                    <p v-if="scope.row.status === `0`">{{$t('common.closed')}}</p>
                    <p v-if="scope.row.status === `2`">{{$t('rma.reopen')}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="trackingNumber" :label="$t('common.trackingNumber')">
                <template slot-scope="scope">
                    <el-button type="text" @click="trackingNumberToUrl(scope.row.trackingNumber)">
                        {{ scope.row.trackingNumber }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="modelNumber" :label="$t('common.modelNum')"></el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right" width="180" v-if="$isFullAdmin">
                <template slot-scope="scope">
                    <el-button size="mini" @click="showPreviewRma(scope.row.rmaNumber)">
                        <i class="el-icon-view"></i>
                    </el-button>
                    <el-button size="mini" @click="showEditRma(scope.row.rmaNumber)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button size="mini" type="danger" @click="deleteRma(scope.row.rmaNumber)">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="total">
        </el-pagination>

        <create-update-rma-dialog :rmaId="rmaToEdit" :visible="updateRmaVisible" @dialogClosed="updateRmaFinished"
            @showRmaConfirm="showRmaConfirm"></create-update-rma-dialog>
        <preview-rma-dialog :rmaId="rmaToView" :visible="previewRmaVisible" @dialogClosed="previewRmaFinished">
        </preview-rma-dialog>
    </div>
</template>

<script>
import Vue from "vue";
import api from "../api";
import CreateUpdateRmaDialog from "./CreateUpdateRma";
import PreviewRmaDialog from "./PreviewRmaDialog";
import { EventBus } from "@/app/event-bus.js";

export default {
    name: "rma",
    components: {
        CreateUpdateRmaDialog,
        PreviewRmaDialog
    },
    props: {

    },
    data() {
        return {
            loading: true,
            filter: {
                text: undefined
            },
            sorting: {},
            currentPage: 1,
            total: 0,
            rmaList: [],
            rmaToView: undefined,
            rmaToEdit: undefined,
            updateRmaVisible: false,
            previewRmaVisible: false,
            isForPartial: false,
            rmaTicketList: []
        };
    },
    methods: {
        loadRma() {
            this.loading = true;
            api.getRMAs(this.currentPage, this.sorting, this.filter).then(response => {
                this.loading = false;
                this.rmaList = response.data.items;
                this.total = response.data.total;
            });
        },
        sortRma(sort) {
            let sortBy = sort.prop;
            if (!sortBy && sort.column != null) {
                sortBy = sort.column.label;
            }
            let sortOrder = sort.order;
            this.sorting = {
                sortBy,
                sortOrder
            };
            if (this.currentPage === 1) {
                this.loadRma();
            } else {
                this.currentPage = 1;
            }
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            this.loadRma();
        },
        deleteRma(id) {
            this.$confirm(this.$t('common.thisWillDeleteRMAContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            })
                .then(() => {
                    api.deleteRma(id).then(() => {
                        this.loadRma();
                        this.$message({
                            type: "success",
                            message: this.$t('common.deleteCompleted')
                        });
                    });
                })
                .catch(_ => { });
        },
        updateRmaFinished() {
            this.rmaToEdit = undefined;
            this.updateRmaVisible = false;
        },
        showPreviewRma(id) {
            console.log(id)
            this.rmaToView = id;
            this.previewRmaVisible = true;
        },
        showRmaConfirm(id) {
            this.rmaToView = id;
            this.previewRmaVisible = true;
        },
        previewRmaFinished() {
            this.rmaToView = undefined;
            this.previewRmaVisible = false;
        },
        showEditRma(id) {
            this.rmaToEdit = id;
            this.updateRmaVisible = true;
        },
        trackingNumberToUrl: function (trackingNumber) {
            if (trackingNumber) {
                let tnum = trackingNumber.match(/^\s*(.*?)\s*$/)[1];
                let tnumEscaped = encodeURIComponent(tnum);
                if (/^(?:1Z[A-Z0-9]{16}|\d{9}|T\d{10})$/.test(tnum)) {
                    let url = 'https://wwwapps.ups.com/tracking/tracking.cgi?tracknum=' + tnumEscaped
                    window.open(url, '_blank')
                } else {
                    return null;
                }
            }
        }
    },
    computed: {

    },
    created() {
        this.loadRma();
    },
    watch: {
        filter: {
            deep: true,
            handler: function (val) {
                this.loadRma();
            }
        }
    },
    mounted() {
        EventBus.$on("showRmaConfirm", rmaId => {
            this.showRmaConfirm(rmaId);
        });
    }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ClientApp/app/rma/components/RMA.vue